import React from "react";
import { ReactComponent as EMAIL } from "../img/social_icons/email_icon.svg";

export const Email = () => {
  return <EMAIL title="email" />;
};
